<template>
    <div class="is-danger has-text-danger">
        <slot v-if="canSubmitLate">
            {{ translate('late_submissions') }}
        </slot>
        <slot v-else>
            {{ translate('no_late_submissions') }}
        </slot>
    </div>
</template>

<script>
import { useI18n } from 'vue-i18n';

export default {
    name: 'LateNotice',

    props: {
        canSubmitLate: {
            type: Boolean,
            required: false,
            default: true,
        },
    },

    setup() {
        const { t: translate } = useI18n();

        return { translate };
    },
};
</script>
